export * from './OtpInput';
export { default } from './OtpInput';
//# sourceMappingURL=index.js.map